import React from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { Check, Edit2, Trash2, X } from "react-feather";

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    CustomDropDown,
    LinearLoading
} from 'common'


const TableBanks = ({ useFetchInit }) => {

    const {
        //------------- Helpers
        Helpers,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { formatMoney } = Helpers
    const { fetchAllBanks: { dataBanks, loadingFetchAllBanks } } = FetchData

    const {
        handleClickFetchSpecificBank,
        handleClickToggleStateBank,
        handleClickDeleteBank
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                const { idbanco, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <>
                        <TooltipInformation
                            idregistro={idbanco}
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>

                )
            }
        },
        { field: 'nombre', headerName: 'Banco', filter: true, minWidth: 400 },
        { field: 'currency_type', headerName: 'MONEDA', filter: true, minWidth: 150 },
        {
            field: 'saldo_quetzales',
            headerName: 'Total Q.',
            filter: true,
            minWidth: 200,
            valueFormatter: (params) => `Q. ${formatMoney(params.value)}`
        },
        {
            field: 'saldo_dolares',
            headerName: 'Total $.',
            filter: true,
            minWidth: 200,
            valueFormatter: (params) => `$ ${formatMoney(params.value)}`
        },
        {
            headerName: 'OPCIONES',
            minWidth: 300,
            cellRenderer: (params) => {
                const { idbanco, estado } = params.data
                return (
                    <CustomDropDown color={(estado === 1) ? 'inherit' : 'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificBank(idbanco)}
                                >
                                    <ListItemIcon> <Edit2 color="black" /> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteBank(idbanco)}
                                >
                                    <ListItemIcon> <Trash2 color="black" /> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickToggleStateBank(idbanco, estado)}
                                >
                                    <ListItemIcon> <X color="black" /> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickToggleStateBank(idbanco, estado)}
                            >
                                <ListItemIcon> <Check color="black" /> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>

                )
            }
        }
    ]

    return (
        <div className="content">
            {loadingFetchAllBanks && (<LinearLoading />)}
            <CustomTableData
                rowConfig={dataBanks}
                columnConfig={columnConfig}
            />
        </div>
    )
}

export {
    TableBanks
}